import createHttpClient from '@/api/httpClient'
import LoadingBackdropService from '@/components/feedback/loadingBackdrop/loadingBackdropService'

interface Discipline {
  id: string // '018f958b-194d-75f6-a005-7137a996b369'
  name: string //'Acupuncteur'
  slug: string //'acupuncteur'
}

const httpClient = createHttpClient()

/**
 * Return the discipline slug or the value entered if the discipline doesn't exist
 * it happens in the case the user type in the url field in the browser
 * @param disciplineString | either name or slug or whatever we entered in the url
 */
export const getDisciplineSlug = async (disciplineString: string) => {
  // LoadingBackdropService.start()
  // const { data: disciplineList, status } =
  //   await httpClient.get<Discipline[]>('/discipline/list')
  // LoadingBackdropService.stop()
  // if (status === 200) {
  //   const disciplineItem = disciplineList.find(
  //     d => d.name === disciplineString || d.slug === disciplineString,
  //   )
  //   if (disciplineItem) return disciplineItem.slug
  // }
  // slugify the discipline string
  return disciplineString
    ? disciplineString
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
    : ''
}
